<template>
    <div class="layout__container">
        <div class="layout__width-80 layout__padding-clear">
            <div class="layout__padding-20-0">
                <div class="layout__position-left layout__width-100 layout__padding__top-20px">
                    <h2 class="text__align-center text__colour-teal layout__margin__top-10">My Preferences</h2>
                </div>
            </div>
        </div>
        <div class="colour__background-light-grey layout__overflow-hidden layout__width-100 layout__padding-20-0">
            <h3 class="text__align-center text__colour-teal layout__margin__top-10">Select Category</h3>
            <div class="layout__padding-clear layout__width-90">
                <div class="component__product__card-small layout__cursor-pointer"
                     v-on:click="selectCategory('Banners & Display boards')">
                    <div class="component__product__card-body">
                        <img class="layout__width-100"
                             src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/digital/digiwindowcard.png">
                        <div class="component__product__card-small-subtitle-text">Banners & Display Boards</div>
                    </div>
                </div>

                <div class="component__product__card-small layout__cursor-pointer" v-on:click="selectCategory('Brochures')">
                    <div class="component__product__card-body">
                        <img class="layout__width-100"
                             src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/propertybrochure.jpg">
                        <div class="component__product__card-small-subtitle-text">Brochures</div>
                    </div>
                </div>

                <div class="component__product__card-small layout__cursor-pointer"
                     v-on:click="selectCategory('Greetings Cards & Invitations')">
                    <div class="component__product__card-body">
                        <img class="layout__width-100"
                             src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/newhomecard.jpg">
                        <div class="component__product__card-small-subtitle-text">Greetings Cards & Invitations</div>
                    </div>
                </div>

                <div class="component__product__card-small layout__cursor-pointer"
                     v-on:click="selectCategory('Leaflets & Flyers')">
                    <div class="component__product__card-body">
                        <img class="layout__width-100"
                             src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/flyers.jpg">
                        <div class="component__product__card-small-subtitle-text">Leaflets & Flyers</div>
                    </div>
                </div>

                <div class="component__product__card-small layout__cursor-pointer" v-on:click="selectCategory('Stationery')">
                    <div class="component__product__card-body">
                        <img class="layout__width-100"
                             src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/stationeryset.jpg">
                        <div class="component__product__card-small-subtitle-text">Stationery</div>
                    </div>
                </div>


                <div class="component__product__card-small layout__cursor-pointer"
                     v-on:click="selectCategory('Window cards & Posters')">
                    <div class="component__product__card-body">
                        <img class="layout__width-100"
                             src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/windowcards.jpg">
                        <div class="component__product__card-small-subtitle-text">Window Cards & Posters</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="layout__width-100">
            <div class="layout__padding-20-0">
                <div class="layout__padding-clear layout__width-90">
                    <GetAPrice ref="price" v-bind:finalised="finalised" v-bind:category="category" v-bind:preferences="preferences"></GetAPrice>
                </div>
            </div>
        </div>
        <el-button class="button-teal button__base layout__width-250px layout__position-center"
                   :disabled="!finalised"
                   v-on:click="savePreferences()">Save my preferences
        </el-button>


        <div class="layout__padding-20-0">
            <div class="text__colour-teal layout__padding-clear layout__width-50">
                <p id="successful"></p>
                <p id="fail"></p>
            </div>
        </div>

    </div>
</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {pagination} from '@/mixins/Pagination.js';
    import GetAPrice from '../../components/productServices/print/GetAPrice.vue';
    import {Loading} from 'element-ui';

    export default {
        name: "preferences",
        mixins: [axios, csvDownloadHelper, dataFormatter, pagination],
        components: {
            GetAPrice
        },
        props: {
            printSpec: Object,
            category: String,
        },
        data() {
            return {
                preferences: {
                    price_code: '',
                    quantity: ''
                },
                loading: false,
                finalised: false,
                // category: 'Banners & Display boards',
                subCatStationery: [
                    {
                        title: 'Document Folder',
                        name: 'Docufolders',
                        finishedSizeFilter: 'A4',
                        finishedOrientationFilter: 'PORTRAIT',
                        foldTypeFilter: 'FOLDED',
                        creasingFilter: 'SIDEFOLD',
                        pageCountFilter: '4'
                    },
                    {
                        title: 'Business Card',
                        name: 'Business Card',
                        finishedSizeFilter: '85mm x 55mm',
                        finishedOrientationFilter: 'LANDSCAPE',
                        foldTypeFilter: 'FLAT',
                        creasingFilter: 'N/A',
                    },
                    {
                        title: 'Compliment Slip',
                        name: 'Compliment Slip',
                        finishedSizeFilter: '210mm x 99mm',
                        finishedOrientationFilter: 'LANDSCAPE',
                        foldTypeFilter: 'FLAT',
                        creasingFilter: 'N/A',
                        pageCountFilter: '1'
                    },
                    {
                        title: 'Letterhead',
                        name: 'Letterhead',
                        finishedSizeFilter: 'A4',
                        finishedOrientationFilter: 'PORTRAIT',
                        foldTypeFilter: 'FLAT',
                        creasingFilter: 'N/A',
                        pageCountFilter: '1'
                    }

                ],
                subCatBanners: [
                    {
                        title: 'Display boards',
                        name: 'Display boards',
                        foldTypeFilter: 'FLAT',
                        creasingFilter: 'N/A',
                        pageCountFilter: '1',
                        laminationFilter: 'NONE',

                    },
                    {
                        title: 'Banners',
                        name: 'Banners',
                        foldTypeFilter: 'FLAT',
                        creasingFilter: 'N/A',
                        pageCountFilter: '1',
                        laminationFilter: 'NONE',
                    }

                ],
                // printSpec: {
                //     subCategory: '',
                //     finishedSizeFilter: '',
                //     finishedOrientationFilter: '',
                //     foldTypeFilter: '',
                //     creasingFilter: '',
                //     pageCountFilter: ''
                // }

            }
        },
        mounted() {

            // need to skip the click and go straight to

            console.log('entering preferences page - created method')
            console.log(this.printSpec)
            console.log(this.category)



            if (this.category !== '') {
                console.log('entering the show options for the click through')
                this.$refs.price.prepopulatedPreferences(this.category, this.printSpec);
            }

            document.getElementById("successful").style.display = 'none';
            document.getElementById("fail").style.display = 'none';


        },
        methods: {
            selectCategory(name) {
                this.$refs.price.selectCategory(name);








                this.category = name;
                // console.log('@@@@@@@@ select category')
                // console.log(this.category)
                //
                //
                // this.printSpec.subCategory = '';
                // this.printSpec.finishedSizeFilter = '';
                // this.printSpec.finishedOrientationFilter = '';
                // this.printSpec.foldTypeFilter = '';
                // this.printSpec.creasingFilter = '';
                // this.printSpec.pageCountFilter = '';

                this.$refs.price.showOptions();


            },
            // selectSubCategory(subCategory) {
            //
            //
            //     this.$refs.price.selectCategory(this.category)
            //     console.log('@@@@@@@@ select sub category')
            //     console.log(this.category)
            //     console.log(subCategory.name)
            //
            //     this.printJobSpec = {}
            //     this.printSpec.subCategory = subCategory.name;
            //     this.printSpec.finishedSizeFilter = subCategory.finishedSizeFilter;
            //     this.printSpec.finishedOrientationFilter = subCategory.finishedOrientationFilter;
            //     this.printSpec.foldTypeFilter = subCategory.foldTypeFilter;
            //     this.printSpec.creasingFilter = subCategory.creasingFilter;
            //     this.printSpec.pageCountFilter = subCategory.pageCountFilter;
            //     this.printSpec.laminationFilter = subCategory.laminationFilter;
            //     this.$refs.price.setSub(this.printSpec);
            //
            // },
            savePreferences() {

                let loadingInstance = Loading.service({
                    fullscreen: true
                });

                let customerRef = JSON.parse(this.returnCookie('_customer')).ref

                console.log(customerRef)

                let skuFinder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/SaveCatalogueBookmark/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&customerRef=` + customerRef + '&priceCode=' + this.preferences.price_code + '&quantity=' + this.preferences.quantity

                console.log(skuFinder)

                console.log(this.returnHeaderUsingToken())

                Axios.put(skuFinder, {}, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });

                        document.getElementById("successful").innerText = "Preference successfully saved"
                        document.getElementById("successful").classList.add('component__message-base', 'component__message-success')
                        document.getElementById("successful").style.display = 'block';

                        this.getUserPreferences(JSON.parse(this.returnCookie("_customer")).ref)

                    })
                    .catch(error => {
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });

                        document.getElementById("fail").innerText = "There was a problem saving preference. Please try again"
                        document.getElementById("fail").classList.add('component__message-base', 'component__message-fail')
                        document.getElementById("fail").style.display = 'block';
                    })

            }
        }
    };
</script>

